import { useEffect, useState } from 'react';
import {
  KpiCompany,
  useKpiCompanyListLazyQuery,
  useKpiCompanyUpdateTemplateMutation,
} from 'generated/graphql';
import { useStores } from 'hooks/useStores';
import moment from 'moment';

export interface FilterForm {
  search?: string;
  fund?: string | number;
  sector?: string | number;
  investment?: number;
}

export function filterCompanies(filter: FilterForm, companies: KpiCompany[]) {
  let filtered = companies;
  if (filter.search) {
    filtered = filtered.filter(
      (company) =>
        company.name
          ?.toLowerCase()
          .includes(filter.search?.toLowerCase() || '') ||
        // FixMe
        // @ts-ignore
        company.template?.name
          .toLowerCase()
          .includes(filter.search?.toLowerCase() || '') ||
        moment(company.updated)
          .format('MM/DD/YYYY')
          .includes(filter.search?.toLowerCase() || ''),
    );
  }
  if (filter.fund) {
    filtered = filtered.filter((company) =>
      company.investments?.find(
        (investment) => investment && investment.fundName === filter.fund,
      ),
    );
  }
  if (filter.sector) {
    filtered = filtered.filter((company) => {
      if (filter.sector?.toString() === '1') return !company.sectors?.length;
      else return company.sectors?.find((sector) => sector === filter.sector);
    });
  }
  if (filter.investment) {
    filtered = filtered.filter((company) => {
      if (!company.investments?.length) return false;
      let investments = company.investments
        ?.filter((investment) => {
          if (filter.fund) {
            return investment?.fundName === filter.fund;
          } else return true;
        })
        .map((investment) => investment?.investmentAmount || 0);
      const investmentAmount = investments.reduce((a, b) => a + b, 0);
      return filter.investment?.toString() === '1'
        ? investmentAmount <= 1000000
        : investmentAmount >= 1000000;
    });
  }
  return filtered;
}

export const useCompany = () => {
  const [getCompanies, { loading, error, data }] = useKpiCompanyListLazyQuery();
  const [assignTemplate] = useKpiCompanyUpdateTemplateMutation();

  const { KPIStore } = useStores();
  const [companies, setCompanies] = useState<KpiCompany[]>([]);
  const [funds, setFunds] = useState<React.ReactText[]>([]);
  const [sectors, setSectors] = useState<String[]>([]);

  useEffect(() => {
    if (data && data.kpiCompanyList) {
      // @ts-ignore
      setCompanies(data.kpiCompanyList);
      // @ts-ignore
      KPIStore.companies = data?.kpiCompanyList;
      let funds = new Set<any>();
      let sectors = new Set<String>();
      for (const company of KPIStore.companies) {
        company.investments?.forEach((investment) => {
          funds.add(investment?.fundName || '');
        });
        company.sectors?.forEach((sector) => {
          sectors.add(sector || '');
        });
      }
      setFunds(Array.from(funds));
      setSectors(Array.from(sectors));
    }
  }, [data?.kpiCompanyList]);

  return {
    models: {
      loading,
      error,
      companies,
      funds,
      sectors,
    },
    operations: {
      handleFiltering: (filter: FilterForm) => {
        setCompanies(filterCompanies(filter, KPIStore.companies));
      },
      loadCompanies: () => getCompanies(),
      assignTemplate: async (companies: KpiCompany[], templateId: string) => {
        for (const company of companies) {
          await assignTemplate({
            variables: {
              id: company.id || '',
              templateId: templateId,
            },
          });
        }
        return {};
      },
      unassignTemplate: async (companies: KpiCompany[]) => {
        for (const company of companies) {
          await assignTemplate({
            variables: {
              id: company.id || '',
              templateId: null,
            },
          });
        }
        return {};
      },
    },
  };
};
